import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const SearchResultTableTHead = () => (
	<TableHeader className="relative bg-bg-layer-400">
		<TableRow className="hover:bg-transparent">
			<TableHead justifyStyle="center" className="font-semibold"></TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				合計収支
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				決済確定日
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				購入者名
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				購入項目
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				予約番号/レシートID
			</TableHead>

			<TableHead justifyStyle="center" className="whitespace-nowrap font-semibold"></TableHead>
		</TableRow>
	</TableHeader>
);
